import { useState } from "react";

export const useFormData = () => {
  const [dashboardImage, setDashboardImage] = useState(null);
  const [vinImage, setVinImage] = useState(null);
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [vehicleMake, setVehicleMake] = useState("");
  const [vehicleModel, setVehicleModel] = useState("");
  const [vehicleYear, setVehicleYear] = useState("");

  const updateDashboardImage = (image) => {
    setDashboardImage(image);
  };

  const updateVinImage = (image) => {
    setVinImage(image);
  };

  const updateDescription = (text) => {
    setDescription(text);
  };

  const updateName = (text) => {
    setName(text);
  };

  const updateEmail = (text) => {
    setEmail(text);
  };

  const updatePhone = (text) => {
    // Only allow numbers, spaces, +, -, (, )
    const phoneRegex = /^[0-9\s\+\-\(\)]*$/;
    if (phoneRegex.test(text)) {
      setPhone(text);
    }
  };

  const updateVehicleMake = (text) => {
    setVehicleMake(text);
  };

  const updateVehicleModel = (text) => {
    setVehicleModel(text);
  };

  const updateVehicleYear = (text) => {
    // Only allow numbers and limit to 4 digits
    const yearRegex = /^[0-9]{0,4}$/;
    if (yearRegex.test(text)) {
      setVehicleYear(text);
    }
  };

  const resetForm = () => {
    setDashboardImage(null);
    setVinImage(null);
    setDescription("");
    setName("");
    setEmail("");
    setPhone("");
    setVehicleMake("");
    setVehicleModel("");
    setVehicleYear("");
  };

  const isFormValid = () => {
    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid = !email.trim() || emailRegex.test(email.trim());

    // Validar que al menos tengamos información básica del vehículo O imágenes
    const hasVehicleInfo = vehicleMake.trim() && vehicleModel.trim() && vehicleYear.trim();
    const hasImages = dashboardImage || vinImage;
    const hasDescription = description.trim();

    const valid =
      name.trim() &&
      phone.trim() &&
      isEmailValid &&
      hasDescription &&
      (hasVehicleInfo || hasImages);
      
    return valid;
  };

  return {
    dashboardImage,
    vinImage,
    description,
    name,
    email,
    phone,
    vehicleMake,
    vehicleModel,
    vehicleYear,
    updateDashboardImage,
    updateVinImage,
    updateDescription,
    updateName,
    updateEmail,
    updatePhone,
    updateVehicleMake,
    updateVehicleModel,
    updateVehicleYear,
    resetForm,
    isFormValid,
  };
};
